import React from 'react';
import moment, {Moment, MomentInput} from 'moment'
import { DateFormats } from "../../../constants/securspace-constants";
import DatePicker from '../DatePicker/DatePicker';

type BoundDatePickerProps<T> = {
  name?: string,
  /** identifies field name to users & screen readers */
  label?: string,
  value?: MomentInput,
  /** if true, this prevents the onChange handler from triggering when an invalid date is provided*/
  suppressEventsForInvalidDates?: boolean,
  /** Callback fired when the date value changes. Receives a Moment object or null. */
  onChange: (newQuery: T) => void;
  /** prevent future dates from being selected if true (default is false)*/
  disableFuture?: boolean,
  /** set the minimum date that can be selected*/
  minDate?: MomentInput,
  /** set the maximum date that can be selected*/
  maxDate?: MomentInput,
  dateFormat?: string,
  /** any other props for MUI DatePicker */
  [key: string]: any,

}

const BoundDatePicker = <T,>({
  name = "",
  label = 'Default Label',
  value,
  onChange = () => {},
  suppressEventsForInvalidDates = true,
  disableFuture = undefined,
  minDate = moment('01/01/1901', DateFormats.DAY),
  maxDate = undefined,
  dateFormat = DateFormats.DAY,
  ...props
}: BoundDatePickerProps<T>) => {

  const onDateChange = (event: Moment | null) => {
    onChange({
      [name]: moment(event).format(dateFormat).toString() ?? ''
    } as unknown as T);
  }

  return <DatePicker
    name={name}
    label={label}
    value={value}
    onChange={onDateChange}
    suppressEventsForInvalidDates={suppressEventsForInvalidDates}
    disableFuture={disableFuture}
    minDate={minDate}
    maxDate={maxDate}
    dateFormat={dateFormat}
    {...props}
  />
}

export { BoundDatePicker };